import { createApp } from 'vue'
import App from "./App.vue"
import router from './router'

import naive from 'naive-ui'
import mdiVue from 'mdi-vue/v3'
import * as mdijs from '@mdi/js'
import VueTippy from 'vue-tippy'
import VueSpeedometer from 'vue-speedometer';


import './assets/css/style.css'
import './assets/css/space-helper.css'

import { plugin as storePlugin } from './stores'
import KeyCloakService from './security/KeycloakService'


const renderApp = () => {

    const app = createApp(App)

    app.component('VueSpeedometer', VueSpeedometer);

    app
        .use(storePlugin)
        .use(naive)
        .use(mdiVue, {
            icons: mdijs
        })
        .use(VueTippy, {
            directive: "tippy", // => v-tippy
            component: "tippy", // => <tippy/>
            componentSingleton: "tippy-singleton", // => <tippy-singleton/>,
            defaultProps: {
            delay: 0,
            duration: [0],
            placement: "top",
            allowHTML: true,
            theme: "tooltip",
            },
        })
        .use(router)
        .mount('#app')
        

};
KeyCloakService.InitApp(renderApp);
